// utils/request.js
import axios from "axios";
import store from "../store"; // 引入 Vuex store
import { Message } from "element-ui";
import { baseURLapp } from "./anyURL";

const service = axios.create({
  baseURL: baseURLapp, // 你的 API 地址
  timeout: 60000,
});

// 请求拦截器
service.interceptors.request.use(
  (config) => {
    // 优先从 Vuex 取，如果刷新后 Vuex 丢失则从 localStorage 取

    // 请求拦截器中获取 token
    let token = store.state.token; // 直接访问 state.token
    if (!token) {
      token = localStorage.getItem("token");
      if (token) {
        store.commit("SET_TOKEN", token); // 使用 mutation
      }
    }
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    const res = response.data;
    if (res.code == "000000") {
      return res;
    } else {
      const msg = Message({
        message: res.message || "服务器繁忙，请刷新重试",
        type: "error",
        duration: 3 * 1000,
      });
      if (msg && msg.$el) msg.$el.style.zIndex = 10000000;
      return res;
    }
  },
  (error) => {
    console.log("err" + error); // for debug
    const msg = Message({
      message: "服务器繁忙，请刷新重试",
      type: "error",
      duration: 3 * 1000,
    });
    if (msg && msg.$el) msg.$el.style.zIndex = 10000000;
    return Promise.reject(error);
  }
);

export default service;
